import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "@/pages/Home";
import SmoothScroll from "@/components/site/SmoothScroll";
import Cursor from "@/components/site/Cursor";

function App() {
  useEffect(() => {
    document.title = "Acervo 3D — A fusão entre arte digital e precisão material";
  }, []);

  return (
    <div className="App grain vignette">
      <SmoothScroll>
        <Cursor />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </BrowserRouter>
      </SmoothScroll>
    </div>
  );
}

export default App;
